<template>

	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$tt('运营商')" :label-width="60">
				<Select filterable clearable style="width: 120px;" v-model="formInline.OperatorId">
					<Option v-bind:key="item.Id" v-for="(item) in OperatorList" :value="item.Id">{{item.Name}}</Option>
					<!-- <span slot="prepend">{{$tt('联系电话')}}</span> -->
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="$tt('充电站')" :label-width="60">
				<Select filterable :placeholder="$tt('站点列表')" style="width: 120px;" v-model="formInline.StationId">
					<Option :value="0">{{$tt('全部')}}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="$tt('工作状态')" :label-width="70">
				<Select filterable :placeholder="$tt('工作状态')" style="width: 120px;" v-model="formInline.Status">
					<Option value="">{{$tt('全部')}}</Option>
					<Option :value="0">{{$tt('空闲')}}</Option>
					<Option :value="2">{{$tt('充电中')}}</Option>
					<Option :value="6">{{$tt('故障')}}</Option>
					<Option :value="-1">{{$tt('离线')}}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="$tt('设备编号')" :label-width="70">
				<Input type="text" style="width: 120px;" v-model="formInline.EquipmentNo" :placeholder="$tt('设备编号')" />
			</FormItem>
			<FormItem prop="trackName" :label="$tt('设备序列号')" :label-width="85">
				<Input type="text" style="width: 120px;" v-model="formInline.EquipmentSerialNo" :placeholder="$tt('设备序列号')" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="pageParam" :url="getChargingInfoUrl" @listData='getDeviceData'>
			</MyPage>
		</Table>
		<!-- <Modal ref="ChargingCurvesModel" width="70%" v-model="modalView" :title="modal.Title">
			<div id="ChargingCurves" style="width:100%;height:300px;"> </div>
			<div slot="footer">
				<Button type="success" size="large" @click="show('closeModal')">{{$tt('确定')}}</Button>
			</div>
		</Modal> -->
		<!-- <echartModal ref="echartModal" curvesName="realChargingCurves"></echartModal> -->
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import Qs from 'qs'
	// import expandRow from './ChargingInfoExpand.vue';
	import echart from '../../../js/echarts_hot.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			echartModal
		},
		data() {
			return {
				getChargingInfoUrl: webapi.base_api_url + '/Operations/GetEqumentStatusBase',
				Control: {},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				tableHeight: "650",
				modal: {
					Title: this.$tt('设备信息添加'),
					type: "addDevice"
				},
				modalView: false,
				BreadcrumbList: [this.$tt('场站监控'), '>>', this.$tt('设备状态')],
				formInline: {
					StationId: 0,
					EquipmentNo: '',
					EquipmentSerialNo: '',
					Status: null,
				},
				//table标题数据
				columns1: [
					// {
					// 	type: 'expand',
					// 	width: 50,
					// 	// render: (h, params) => {
					// 	// 	return h(expandRow, {
					// 	// 		props: {
					// 	// 			row: params.row
					// 	// 		}
					// 	// 	})
					// 	// }
					// },
					{
						title: 'ID',
						key: 'ConnectorId',
						width: 100,
					},
					{
						title: this.$tt('充电枪编号'),
						key: 'ConnectorNo',
						minWidth: 100,
					},
					{
						title: this.$tt('设备序列号'),
						key: 'EquipmentSerialNo',
						minWidth: 100,
					},
					{
						title: this.$tt('工作状态'),
						key: 'WorkStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('Tag', {
									props: {
										color: params.row.WorkStatus == 2 ? 'primary' : params.row.WorkStatus == 6 ? 'warning' : params
											.row.WorkStatus == -1 ? 'default' : 'success',
								},
								style: {
									width: '60px',
									textAlign: 'center'
								}
							},
							// 用枚举数值取当前语言的描述，取不到时退回后端返回的 WorkStatusDesc
							this.$tEnum('WorkStatus', params.row.WorkStatus, params.row.WorkStatusDesc)
							);
							}
					},
					{
						title: this.$tt('连接状态'),
						key: 'CarCoupleStatus',
						minWidth: 100,
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.CarCoupleStatus) {
								case 0:
									color = "default"
									break;
								default:
									color = "success"
									break;
							}
							// 连接状态同样走枚举字典，取不到时退回后端描述
							type = this.$tEnum('CarCoupleStatus', params.row.CarCoupleStatus, params.row
								.CarCoupleStatusDesc)
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: this.$tt('最高告警码'),
						key: 'MaxAlarmCode',
						minWidth: 100,
						render: (h, params) => {
							let type = ''
							let color = ''
							switch (params.row.MaxAlarmCode) {
								case 0:
									color = params.row.WorkStatus === -1 ? 'default' : "green",
										type = this.$tt('无告警')
									break;
								default:
									color = "warning",
										type = params.row.MaxAlarmDesc
									break;
							}
							return h('Tag', {
									props: {
										color: color
									}
								},
								type
							);
						}
					},
					{
						title: this.$tt('信号强度'),
						key: 'SimRssi',
						minWidth: 100,
						render: (h, params) => {
							const grayscale = params.row.WorkStatus == -1 ? 'grayscale(90%)' : '';
							//return h('div', (params.row.SimRssi === 255 || params.row.SimRssi === 0) ? '-' : params.row.SimRssi);
							if ((params.row.SimRssi > 0 && params.row.SimRssi < 20) || (params.row.SimRssi >= -156 && params.row.SimRssi < -105)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-1.png') },
									style: { width: '20px', filter: grayscale }
								});
							} else if ((params.row.SimRssi >= 20 && params.row.SimRssi < 23) || (params.row.SimRssi >= -105 && params.row.SimRssi < -95)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-2.png') },
									style: { width: '20px', filter: grayscale }
								});
							} else if ((params.row.SimRssi >= 23 && params.row.SimRssi < 26) || (params.row.SimRssi >= -95 && params.row.SimRssi < -88)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-3.png') },
									style: { width: '20px', filter: grayscale }
								});
							} else if ((params.row.SimRssi >= 26 && params.row.SimRssi < 29) || (params.row.SimRssi >= -88 && params.row.SimRssi < -80)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-4.png') },
									style: { width: '20px', filter: grayscale }
								});
							} else if ((params.row.SimRssi >= 29 && params.row.SimRssi < 33) || (params.row.SimRssi >= -80 && params.row.SimRssi < -43)) {
								return h('img', {
									attrs: { src: require('@/assets/rssi-5.png') },
									style: { width: '20px', filter: grayscale }
								});
							}
						}
					},
					{
						title: this.$tt('联网类型'),
						key: 'NetworkType',
						minWidth: 100,
						render: (h, params) => {
							return h('div', `${params.row.NetworkType}-${this.$tEnum('NetworkType', params.row.NetworkType, params.row.NetworkTypeDesc)}`);
						}
					},
					// {
					// 	title: '运营平台在线状态',
					// 	key: 'EquipOnlineStatus',
					// 	minWidth: 100,
					// 	render: (h, params) => {
					// 		return h('div', this.$tEnum('EquipOnlineStatus', params.row.EquipOnlineStatus, params.row.EquipOnlineStatusDesc));
					// 	}
					// },
					{
						title: this.$tt('SIM识别码'),
						key: 'SimIccid',
						minWidth: 120,
					},
					{
						title: this.$tt('设备型号'),
						key: 'EquipmentModel',
						minWidth: 100,
					},
					{
						title: this.$tt('设备类型'),
						key: 'EquipmentType',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								this.$tEnum('EquipmentType', params.row.EquipmentType, params.row.EquipmentTypeDesc)
							);
						}
					},
					// {
					// 	title: '额定功率',
					// 	key: 'RatedPower'
					// },
					{
						title: this.$tt('站点名称'),
						key: 'StationName',
						minWidth: 100
					},


					// , {
					// 	title: '设备编号',
					// 	key: 'EquipmentNo',
					// }, {
					// 	title: '设备名称',
					// 	key: 'EquipmentName',
					// },
					// {
					// 	title: '枪名称',
					// 	key: 'ConnectorName'
					// },
					// {
					// 	title: '设备类型',
					// 	key: 'EquipmentType',
					// 	render: (h, params) => {
					// 		return h('div',
					// 			this.$tEnum('EquipmentType', params.row.EquipmentType, params.row.EquipmentTypeDesc)
					// 		);
					// 	}
					// },
					// {
					// 	title: '枪类型',
					// 	key: 'ConnectorType',
					// 	render: (h, params) => {
					// 		return h('div',
					// 			this.$tEnum('ConnectorType', params.row.ConnectorType, params.row.ConnectorTypeDesc)
					// 		);
					// 	}
					// },
					// {
					// 	title: '操作',
					// 	key: 'action',
					// 	width: 200,
					// 	align: 'center',
					// 	render: (h, params) => {
					// 		console.log(this.Control);
					// 		let MyButton = [];
					// 		if (this.hasWidgets('stopCharge')) {
					// 			MyButton.push(
					// 				h('Button', {
					// 					props: {
					// 						type: 'error',
					// 						size: 'small'
					// 					},
					// 					style: {
					// 						marginRight: '5px'
					// 					},
					// 					on: {
					// 						click: () => {
					// 							this.$Modal.confirm({
					// 								title: '枪：' + params.row.ConnectorNo +
					// 									' 停止充电？',
					// 								okText: '取消',
					// 								cancelText: '确定',
					// 								onCancel: () => {
					// 									this.stopCharging(params.row
					// 										.ConnectorNo);
					// 								}
					// 							});
					// 						}
					// 					}
					// 				}, this.$tt('停止充电'))
					// 			)
					// 		}
					// 		if (this.hasWidgets('chargeCurves')) {
					// 			MyButton.push(
					// 				h('Button', {
					// 					props: {
					// 						type: 'primary',
					// 						size: 'small'
					// 					},
					// 					style: {
					// 						marginRight: '5px'
					// 					},
					// 					on: {
					// 						click: () => {
					// 							this.show("ChargingCurves", params.row.OrderNo)
					// 						}
					// 					}
					// 				}, this.$tt('充电曲线'))
					// 			)
					// 		}
					// 		return h('div', MyButton);
					// 	}
					// }
				],
				data1: [],

				//图标实例
				Myecharts: '',
				//图表数据
				// lineEchart: {
				// 	legend_data: ['电压曲线', '电流曲线', 'SOC曲线', '枪温度曲线'],
				// 	seriesData: [{
				// 			name: '电压曲线',
				// 			type: 'line',
				// 			stack: '分类1',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		},
				// 		{
				// 			name: '电流曲线',
				// 			type: 'line',
				// 			stack: '分类2',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		},
				// 		{
				// 			name: 'SOC曲线',
				// 			type: 'line',
				// 			stack: '分类3',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		},
				// 		{
				// 			name: '枪温度曲线',
				// 			type: 'line',
				// 			stack: '分类4',
				// 			data: [0, 0, 0, 0, 0, 0, 0]
				// 		}
				// 	],
				// 	style: {
				// 		color: "black"
				// 	},
				// 	TimePoins: [1, 2, 3, 4, 5, 6, 7]
				// },
				timer: ''
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 160;
			_this.getTableHeight();
			window.addEventListener('resize', _this.getTableHeight)
			//window.addEventListener('resize', echart.resizeEchart(null))
		},
		activated() {
			// let col = this.$store.state.UserButton.find(item => window.location.href.indexOf(item.path) > 0);
			// this.Control = col.control
			// console.log(col.control);
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
			//window.removeEventListener('resize', echart.resizeEchart(null))
		},
		mounted() {
			const _this = this
			_this.handleSubmit();
		},
		beforeDestroy() {},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},

			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatorList: 'typeList',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			// show: function(type, OrderNo) {
			// 	switch (type) {
			// 		case "ChargingCurves":
			// 			this.modal.type = "ChargingCurves";
			// 			this.modal.Title = this.$tt('充电曲线');
			// 			//this.modalView = true;
			// 			this.$refs.echartModal.show('view', OrderNo)
			// 			//this.getChargingCurves(OrderNo);
			// 			break;
			// 		case "update":
			// 			this.modal.type = "update";
			// 			this.modal.Title = this.$tt('设备信息跟新');
			// 			this.getUpdateMessage(EquipmentNo);
			// 			this.modalView = true;
			// 			break;
			// 		case "closeModal":
			// 			echart.disposeEchart("ChargingCurves")
			// 			this.modalView = false;
			// 			break;
			// 	}
			// },
			// stopCharging: function(ConnectorNo) {
			// 	const _this = this
			// 	_this.$axios.post(webapi.base_api_url + "/Archives/StopCharge", {
			// 		ConnectorNo: ConnectorNo
			// 	}, {
			// 	}).then(res => {
			// 		console.log("停止充电")
			// 		console.log(res.data)
			// 		if (res.data.Code == 0) {
			// 			_this.$Message.info(ConnectorNo + this.$tt('停止充电成功'));
			// 			_this.handleSubmit()
			// 		} else {
			// 			this.$Message.success(res.data.Msg + "---" + res.data.Data);
			// 		}
			// 	})
			// },
			getDeviceData: function(data) {
				console.log("分页ChargingInfo")
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = {
				// 	StationId: _this.formInline.SelectStation
				// }
				// _this.$axios.post(webapi.base_api_url + "/Operations/GetChargingInfo", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.ChargeingInfos;
				// 	}
				// })
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160 - (window.innerWidth < 1286 ? 60 : 0);
			},
			// getChargingCurves: function(OrderNo) {
			// 	const _this = this
			// 	console.log(OrderNo)
			// 	let parms = {
			// 		OrderNo: OrderNo,
			// 	};
			// 	_this.$axios.post(webapi.base_api_url + "/Operations/GetChargingCurves", parms, {
			// 	}).then(res => {
			// 		console.log("实时充电-充电曲线res")
			// 		console.log(res.data)
			// 		if (res.data.Code == 0) {
			// 			let MyTimePoins = []
			// 			res.data.Data.Curves.ReportTime.forEach(function(time) {
			// 				//MyTimePoins.push(time.split(" ")[0])
			// 				MyTimePoins.push(time)
			// 			})
			// 			_this.lineEchart.TimePoins = MyTimePoins;
			// 			_this.lineEchart.seriesData[0].data = res.data.Data.Curves.VoltageCurve;
			// 			_this.lineEchart.seriesData[1].data = res.data.Data.Curves.CurrentCurve;
			// 			_this.lineEchart.seriesData[2].data = res.data.Data.Curves.SocCurve;
			// 			_this.lineEchart.seriesData[3].data = res.data.Data.Curves.TempConnectorCurve;
			// 			echart.initLinechart3("ChargingCurves", _this.lineEchart)
			// 		}
			// 	})
			// }
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
